import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { AgentFormField } from '@/pages/trading/new-trade/fields/AgentFormField'
import { AgentRefNumberFormField } from '@/pages/trading/new-trade/fields/AgentRefNumberFormField'
import { InvestmentBucketIdFormField } from '@/pages/trading/new-trade/fields/InvestmentBucketIdFormField'
import { LockedYTMFormField } from '@/pages/trading/new-trade/fields/LockedYTMFormField'
import { StructureNameFormField } from '@/pages/trading/new-trade/fields/StructureNameFormField'
import { TopLevelBucketIdFormField } from '@/pages/trading/new-trade/fields/TopLevelBucketIdFormField'
import { TradeTypeFormField } from '@/pages/trading/new-trade/fields/TradeTypeFormField'
import { TraderIdFormField } from '@/pages/trading/new-trade/fields/TraderIdFormField'
import { WrapperBucketIdFormField } from '@/pages/trading/new-trade/fields/WrapperBucketIdFormField'
import {
  useAgentsQuery,
  useInvestmentBucketsQuery,
  useTopLevelBucketsQuery,
  useTradeTypesQuery,
  useTradersQuery,
  useWrapperBucketsQuery,
} from '@/react-query/queries/static'

export interface FundStrategyFormFieldsProps {}

export const FundStrategyFormFields: React.FC<FundStrategyFormFieldsProps> = ({}) => {
  const tradersQuery = useTradersQuery()
  const tradeTypesQuery = useTradeTypesQuery()
  const topLevelBucketsQuery = useTopLevelBucketsQuery()
  const investmentBucketsQuery = useInvestmentBucketsQuery()
  const wrapperBucketsQuery = useWrapperBucketsQuery()
  const agentsQuery = useAgentsQuery()

  return (
    <div className="flex flex-col gap-4">
      <FormFieldRow>
        <StructureNameFormField />
      </FormFieldRow>
      <FormFieldRow>
        <TraderIdFormField traders={tradersQuery.data} loading={tradersQuery.isFetching} />
        <TradeTypeFormField
          tradeTypes={tradeTypesQuery.data}
          loading={tradeTypesQuery.isFetching}
        />
        <AgentFormField agents={agentsQuery.data} loading={agentsQuery.isFetching} />
        <AgentRefNumberFormField />
      </FormFieldRow>
      <FormFieldRow>
        <TopLevelBucketIdFormField
          topLevelBuckets={topLevelBucketsQuery.data}
          loading={topLevelBucketsQuery.isFetching}
        />
        <InvestmentBucketIdFormField
          investmentBuckets={investmentBucketsQuery.data}
          loading={investmentBucketsQuery.isFetching}
        />
        <WrapperBucketIdFormField
          wrapperBuckets={wrapperBucketsQuery.data}
          loading={wrapperBucketsQuery.isFetching}
        />
        <LockedYTMFormField />
      </FormFieldRow>
    </div>
  )
}
